import { useGetUsernamesQuery } from "../api/Users";

import type { UUID } from "../../../utils";

export function useUsernames(userIds?: UUID | UUID[]) {
  const {
    data,
    refetch,
    isLoading: areUsernamesLoading,
    isFetching: areUsernamesFetching,
    isError: isUsernamesError,
  } = useGetUsernamesQuery({ userIds }, { skip: !userIds?.length });

  return {
    usernames: data ?? {},
    refetch,
    areUsernamesLoading,
    isUsernamesError,
    areUsernamesFetching,
  };
}
